// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AdminLoginForm-commonHeaderAdmin-xAuxy {
	position: fixed !important;
}

.AdminLoginForm-adminLayout-ZNhsv {
	padding-top: 64px !important;
}

.AdminLoginForm-box-KpZj_ h2 {
	font-size: 21px;
	font-weight: 600;
}

.AdminLoginForm-exportLink-pLWrL {
	margin-bottom: -29px;
}

.AdminLoginForm-blockCenter-Oaw9F {
	float: none !important;
	display: block;
	margin: 0 auto;
	margin-top: 30px;
}

.AdminLoginForm-panelHeader-LCVWK {
	padding-bottom: 18px !important;
	padding: 24px 15px;
	border-radius: 6px !important;
	border: 1px solid var(--primary-border)
}

.AdminLoginForm-currencyselect-IiGZn {
	width: 100%;
	margin-right: 0px;
}

.AdminLoginForm-panelHeader-LCVWK {
	overflow: hidden;
	position: relative;
}

.AdminLoginForm-mar0-g04nY {
	margin-left: 0;
	margin-right: 0;
}

@media screen and (max-width: 767px) {
	.AdminLoginForm-blockCenter-Oaw9F {
		padding: 0px;
	}

	.AdminLoginForm-panelHeader-LCVWK {
		padding: 24px 5px;
	}
}

/** Admin - Common - Start **/

.AdminLoginForm-sideAdminPageWrapper-A6aOk {
	margin-left: var(--siteAdmin-sideBar-width);
	position: relative;
	padding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;
}

.AdminLoginForm-panelHeader-LCVWK {
	border-radius: 0;
	width: 100%;
	display: block;
	font-size: 16px;
	padding-bottom: 12px;
	border-bottom: 1px solid var(--primary-border);
	background-color: var(--background-primary);
}

.AdminLoginForm-table-dpwsJ {
	display: table;
}

.AdminLoginForm-tableRow-jYccS {
	display: table-row;
}

.AdminLoginForm-tableCell-JB3Y0 {
	display: table-cell;
	float: none;
}

.AdminLoginForm-formGroup-zV1G5 {
	margin-bottom: 6px;
}

.AdminLoginForm-select-Pz7lr {
	position: relative;
	display: inline-block;
	vertical-align: bottom;
	margin-right: 5px;
}

.AdminLoginForm-noMargin-i_8Re {
	margin: 0px;
}

a,
a:hover {
	cursor: pointer;
}

.AdminLoginForm-exportLink-pLWrL {
	padding-top: 10px;
	padding-right: 10px;
}

.AdminLoginForm-labelTextNew-MdcX8 {
	font-size: 16px;
	line-height: 24px;
	font-weight: 600;
	margin: 0 0 6px;
	text-align: start;
	color: var(--primary-foreground);
}

.AdminLoginForm-displayInline-Lewtx {
	display: inline-block;
}

/******************* Admin Modal ListSetting Start *******************/

.AdminLoginForm-btnUPdate-oU7lq {
	display: inline-block;
}

.AdminLoginForm-btnModalDelete-Db4_H {
	display: inline-block;
	margin-left: 15px;
}

.AdminLoginForm-radioBtn-LT4oE {
	position: relative;
	top: 1px;
	vertical-align: middle;
}

.AdminLoginForm-backgroundImg-ssCHZ {
	padding-top: 80%;
	background-position: top center;
	background-size: cover;
}

@media screen and (max-width: 767px) {
	.AdminLoginForm-btnUPdate-oU7lq {
		display: block;
		margin-bottom: 12px;
	}

	.AdminLoginForm-btnModalDelete-Db4_H {
		display: block;
		margin-left: 0px;
	}

	.AdminLoginForm-btnWidth-iIFg9 {
		width: 100%;
	}
}

/******************* Admin Modal ListSetting Start *******************/

/******************* Admin Banner Image Section Start ****************/

.AdminLoginForm-bannerImageBg-Y2ZS3 {
	padding-top: 60%;
	background-repeat: no-repeat;
	background-size: contain;
	border-radius: 4px;
	background-position: center;
	background-color: var(--secondary-gray-bg);
	border: 1px dashed var(--primary-border);
}

.AdminLoginForm-bannerDelete-bPGpT {
	position: absolute;
	top: -12px;
	right: 4px;
}

/*******************Admin Modal Start **********************/

.AdminLoginForm-modalRoot-Pfx0Y {
	padding: 32px;
}

.AdminLoginForm-modalBorderBottom-wq5wp {
	border-bottom: 5px solid var(--primary-bg);
	border-bottom-left-radius: 14px;
	border-bottom-right-radius: 14px;
}

.AdminLoginForm-logInModalBody-LCq7y {
	padding: 0px;
}

/*************** Admin TableNew Design Start**************************/

.AdminLoginForm-exportSection-P5dwC {
	background: #f5f5f5;
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border-top-left-radius: 6px;
	border-top-right-radius: 6px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
}

.AdminLoginForm-exportSectionGridSub-z7Lf0 {
	grid-template-columns: 50% 49% !important;
}

.AdminLoginForm-exportText-zMDXf {
	color: var(--primary-foreground) !important;
	text-decoration: none !important;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 12px;
}

.AdminLoginForm-exportLinkImg-Eh2R4 {
	background: var(--common-white-primary-bg);
	padding: 10px;
	border-radius: 4px;
	display: inline-block;
}

.AdminLoginForm-vtrMiddle-s3ctI {
	vertical-align: middle;
}

.AdminLoginForm-exportImg-NO3_N {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.AdminLoginForm-profileViewlabel-lGl8E {
	display: inline-block;
	width: 38%
}

.AdminLoginForm-profileViewMainContent-YjYPL {
	display: inline-block;
	width: 62%;
}

.AdminLoginForm-profileViewMain-yIRiz {
	border: 1px solid var(--primary-border);
	border-radius: 6px;
}

.AdminLoginForm-profileViewInner-GuLXP {
	padding: 10px;
	border-bottom: 1px solid var(--primary-border);
}

.AdminLoginForm-profileImageSection-fQodG {
	width: 100%;
	height: 100px;
	max-width: 100px;
	max-height: 100px;
	border-radius: 50%;
}

.AdminLoginForm-lastviewInner-CNOve {
	padding: 10px;
}

.AdminLoginForm-whyHostHoriLine-LUWXw {
	margin: 30px 0;
}

.AdminLoginForm-tableGrid-vRcn0 {
	display: grid;
	grid-template-columns: 50% 50%;
	-webkit-column-gap: 10px;
	   -moz-column-gap: 10px;
	        column-gap: 10px;
	word-wrap: break-word;
}

.AdminLoginForm-headingContent-fY6qD {
	font-size: 18px;
	font-weight: 500;
}

.AdminLoginForm-refundTextColor-uO92s {
	color: var(--alert-color);
	font-size: 18px;
	text-decoration: line-through;
	text-decoration-thickness: 2px;
	text-decoration-color: var(--black-color);
}

.AdminLoginForm-dividerLine-iOOt9 {
	border-top: 1px solid var(--primary-border);
	margin: 30px 0;
}

.AdminLoginForm-smallContent-kOBdb {
	font-size: 14px;
	margin-top: 6px;
	color: var(--secondary-foreground);
}

@media (max-width: 1200px) and (min-width: 1024px) {
	.AdminLoginForm-sideAdminPageWrapper-A6aOk {
		height: 100%;
		overflow: auto;
	}
}

@media (max-width:1199px) {
	.AdminLoginForm-sideAdminPageWrapper-A6aOk {
		margin-left: 0;
	}
}

@media screen and (max-width: 991px) {
	.AdminLoginForm-exportSection-P5dwC {
		grid-template-columns: 100%;
	}

	.AdminLoginForm-exportSectionGridSub-z7Lf0 {
		grid-template-columns: 100% !important;
	}

}

@media screen and (max-width: 767px) {
	.AdminLoginForm-profileViewlabel-lGl8E {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.AdminLoginForm-profileViewMainContent-YjYPL {
		width: 100%;
		text-align: center;
	}
}

/*************** Admin TableNew Design End**************************/

.AdminLoginForm-ChangeToUpperCase-JwSiL {
	text-transform: uppercase
}

.AdminLoginForm-noBorder-FbkqH {
	border: 0px !important;
}

/** Admin - Common - End **/

/* site Admin utility Start */

.AdminLoginForm-siteAdminHeading-nbRM2 {
	font-size: 24px;
	line-height: 32px;
	font-weight: 700;
	margin: 0 0 24px;
	text-align: start;
	color: var(--primary-foreground);
}

.AdminLoginForm-siteAdminSubHeading-Jfe6Z {
	font-size: 18px;
	line-height: 26px;
	font-weight: 600;
	margin: 0 0 12px;
	text-align: start;
	color: var(--primary-foreground);
}

.AdminLoginForm-adminFormDivider-_CwcF {
	border-top: 1px solid var(--primary-border);
	margin-bottom: 24px;
}

.AdminLoginForm-errorMessage-w3bhr {
  margin: 5px 0px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
}

.AdminLoginForm-panelHeader-LCVWK {
  border-radius: 0;
  width: 100%;
  display: block;
  font-size: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--primary-border);
}

.AdminLoginForm-formGroup-zV1G5 {
  margin-bottom: 6px;
}

.AdminLoginForm-select-Pz7lr {
  position: relative;
  display: inline-block;
  vertical-align: bottom;
  margin-right: 5px;
}

.AdminLoginForm-labelText-c7RYk {
  font-size: 14px;
  color: var(--secondary-foreground);
  margin: 6px 0px;
  line-height: 1.43;
  font-weight: normal;
  vertical-align: middle;
}

.AdminLoginForm-space1-uS0vZ {
	margin-bottom: 6px !important;
}

.AdminLoginForm-space2-C0XyK {
	margin-bottom: 12px !important;
}

.AdminLoginForm-space3-Vd7he {
	margin-bottom: 18px !important;
}

.AdminLoginForm-space4-R8RQA {
	margin-bottom: 24px !important;
}

.AdminLoginForm-space5-BsE7g {
	margin-bottom: 30px !important;
}

.AdminLoginForm-space6-UVaRx {
	margin-bottom: 36px !important;
}

.AdminLoginForm-space7-RFXLY {
	margin-bottom: 42px !important;
}

.AdminLoginForm-spaceTop8-L6vih {
	margin-bottom: 48px !important;
}

.AdminLoginForm-spaceTop1-YGy0m {
	margin-top: 6px !important;
}

.AdminLoginForm-spaceTop2-N6jz1 {
	margin-top: 12px !important;
}

.AdminLoginForm-spaceTop3-Mory8 {
	margin-top: 18px !important;
}

.AdminLoginForm-spaceTop4-JDKRc {
	margin-top: 24px !important;
}

.AdminLoginForm-spaceTop5-n2IoF {
	margin-top: 30px !important;
}

.AdminLoginForm-spaceTop6-jTOxF {
	margin-top: 36px !important;
}

.AdminLoginForm-spaceTop7-LL78l {
	margin-top: 42px !important;
}

.AdminLoginForm-spaceTop8-L6vih {
	margin-top: 48px !important;
}

.AdminLoginForm-noMargin-i_8Re {
	margin: 0px !important;
}

.AdminLoginForm-padding1-Elvxu {
	padding-bottom: 6px !important;
}

.AdminLoginForm-padding2-Cvntx {
	padding-bottom: 12px !important;
}

.AdminLoginForm-padding3-D1Ue1 {
	padding-bottom: 18px !important;
}

.AdminLoginForm-padding4-eKsOE {
	padding-bottom: 24px !important;
}

.AdminLoginForm-padding5-qjgyj {
	padding-bottom: 30px !important;
}

.AdminLoginForm-padding6-WCOah {
	padding-bottom: 36px !important;
}

.AdminLoginForm-padding7-LdHzO {
	padding-bottom: 42px !important;
}

.AdminLoginForm-paddingTop1-TbZGM {
	padding-top: 6px !important;
}

.AdminLoginForm-paddingTop2-L_zmL {
	padding-top: 12px !important;
}

.AdminLoginForm-paddingTop3-uGGks {
	padding-top: 18px !important;
}

.AdminLoginForm-paddingTop4-u1ujn {
	padding-top: 24px !important;
}

.AdminLoginForm-paddingTop5-B4ku8 {
	padding-top: 30px !important;
}

.AdminLoginForm-paddingTop6-JAzzV {
	padding-top: 36px !important;
}

.AdminLoginForm-paddingTop7-u17kr {
	padding-top: 42px !important;
}

.AdminLoginForm-noPadding-vwPF0 {
	padding: 0px !important;
}

.AdminLoginForm-textBold-gylX9 {
	font-weight: 500 !important;
}

.AdminLoginForm-textBolder-p2lyt {
	font-weight: 700 !important;
}

.AdminLoginForm-textNormal-dyYo3 {
	font-weight: normal !important;
}

.AdminLoginForm-spaceBottom20-VG6kQ {
	margin-bottom: 20px;
}

.AdminLoginForm-spaceBottom10-zccoE {
	margin-bottom: 10px;
}

.AdminLoginForm-marginNone-5DLZo {
	margin: 0;
}

.AdminLoginForm-spaceBottom15-lVaL1 {
	margin-bottom: 15px;
}

.AdminLoginForm-marginTopNone-E5TLP {
	margin-top: 0;
}

.AdminLoginForm-spaceTop11-Nm_t8 {
	margin-top: 11px;
}

.AdminLoginForm-spaceTop21-n7wcp {
	margin-top: 21px;
}

.AdminLoginForm-spaceTop20-T8CR2 {
	margin-top: 20px;
}

.AdminLoginForm-spaceTop10-uYrPR {
	margin-top: 10px;
}

/*New Design Text Colors */

.AdminLoginForm-textDarkBlue-w_yWE {
	color: rgb(20, 39, 94) !important;
}

.AdminLoginForm-textLightBlue-I4mJt {
	color: rgb(57, 87, 106) !important;
}

.AdminLoginForm-textLightSandleGreen-ksOIB {
	color: rgb(76, 86, 41) !important;
}

.AdminLoginForm-textLightBrown-a8ufN {
	color: rgb(115, 79, 33) !important;
}

.AdminLoginForm-textMediumMaroon-Nq12N {
	color: rgb(87, 37, 51) !important;
}

.AdminLoginForm-textBrown-HnTOj {
	color: rgb(160, 47, 24) !important;
}

.AdminLoginForm-textMaroon-Zy5ai {
	color: rgb(155, 49, 67) !important;
}

.AdminLoginForm-textDarkBrown-PKPB1 {
	color: rgb(83, 18, 16) !important;
}

.AdminLoginForm-textMediumBrown-S0ZmG {
	color: rgb(142, 28, 10) !important;
}

.AdminLoginForm-textSkyBlue-wu94v {
	color: rgb(37, 117, 141) !important;
}

.AdminLoginForm-textGray-ZkAwj {
	color: rgb(77, 65, 51) !important;
}

.AdminLoginForm-loginMainBg-yMjYH {
  display: grid;
  grid-template-columns: 50% 50%;
  height: 100vh;
}

.AdminLoginForm-formSection-bIAcb {
  padding: 19% 0;
  background-color: var(--primary-gray-bg);
}

.AdminLoginForm-formInner-K8Qah {
  width: 100%;
  max-width: 450px;
  margin: 0 auto;
  padding: 0px 15px;
}

.AdminLoginForm-loginBg-AcqCe {
  width: 100%;
  height: 100%;
  padding-top: 64%;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: 50% 50%;
}

.AdminLoginForm-loginbtn-Mx3Ej {
  padding: 13px 21px !important;
}

.AdminLoginForm-loginInput-YP8KD {
  height: 50px !important;
}

.AdminLoginForm-loginLabel-ZRmax {
  font-weight: 100 !important;
  font-size: 18px !important;
}

.AdminLoginForm-loginTitle-ufieP {
  font-size: 30px;
  font-weight: 700;
  margin: 12px 0 0 0;
}

.AdminLoginForm-loginTitleScetion-sh6M8 {
  text-align: center;
  margin-bottom: 42px;
}

.AdminLoginForm-loginTitleScetion-sh6M8 img {
  width: 100%;
  max-width: 120px;
}

.AdminLoginForm-logoColor-t0imA {
  color: var(--primary-bg);
}

.AdminLoginForm-whiteColor-AsThI {
  color: var(--common-primary-white-foreground);
}

.AdminLoginForm-logoTextTabViewWidth-C5AVC {
  text-overflow: ellipsis;
  overflow: hidden;
  display: block;
  width: 100%;
  max-width: 180px;
  white-space: nowrap;
  margin: auto;
}

.AdminLoginForm-rentalText-w4r_Z {
  font-size: 20px;
  font-weight: 600;
}

@media screen and (max-width: 767px) {
  .AdminLoginForm-loginMainBg-yMjYH {
    grid-template-columns: 100%;
  }

  .AdminLoginForm-loginBg-AcqCe {
    display: none
  }
}`, "",{"version":3,"sources":["webpack://./src/components/siteadmin/newcommonstyle.css","webpack://./src/components/siteadmin/admin-common.css","webpack://./src/components/utils.css","webpack://./src/components/siteadmin/admin-form.css","webpack://./src/components/helpers.css","webpack://./src/components/siteadmin/AdminLoginForm/AdminLoginForm.css"],"names":[],"mappings":"AAAA;CACC,0BAA0B;AAC3B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,sBAAsB;CACtB,cAAc;CACd,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,+BAA+B;CAC/B,kBAAkB;CAClB,6BAA6B;CAC7B;AACD;;AAEA;CACC,WAAW;CACX,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC;EACC,YAAY;CACb;;CAEA;EACC,iBAAiB;CAClB;AACD;;ACpDA,6BAA6B;;AAC7B;CACC,2CAA2C;CAC3C,kBAAkB;CAClB,+DAA+D;AAChE;;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,cAAc;CACd,eAAe;CACf,oBAAoB;CACpB,8CAA8C;CAC9C,2CAA2C;AAC5C;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,sBAAsB;CACtB,iBAAiB;AAClB;;AAEA;CACC,WAAW;AACZ;;AAEA;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,qBAAqB;AACtB;;AAEA,sEAAsE;;AAEtE;CACC,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;CACrB,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,sBAAsB;AACvB;;AAEA;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,sBAAsB;AACvB;;AAEA;CACC;EACC,cAAc;EACd,mBAAmB;CACpB;;CAEA;EACC,cAAc;EACd,gBAAgB;CACjB;;CAEA;EACC,WAAW;CACZ;AACD;;AAEA,sEAAsE;;AAEtE,sEAAsE;;AAEtE;CACC,gBAAgB;CAChB,4BAA4B;CAC5B,wBAAwB;CACxB,kBAAkB;CAClB,2BAA2B;CAC3B,0CAA0C;CAC1C,wCAAwC;AACzC;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,UAAU;AACX;;AAEA,4DAA4D;;AAE5D;CACC,aAAa;AACd;;AAEA;CACC,0CAA0C;CAC1C,+BAA+B;CAC/B,gCAAgC;AACjC;;AAEA;CACC,YAAY;AACb;;AAEA,sEAAsE;;AAEtE;CACC,mBAAmB;CACnB,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,2BAA2B;CAC3B,4BAA4B;CAC5B,uCAAuC;CACvC,gBAAgB;AACjB;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,gCAAgC;CAChC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,0CAA0C;CAC1C,aAAa;CACb,kBAAkB;CAClB,qBAAqB;AACtB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB;AACD;;AAEA;CACC,qBAAqB;CACrB,UAAU;AACX;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,8CAA8C;AAC/C;;AAEA;CACC,WAAW;CACX,aAAa;CACb,gBAAgB;CAChB,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,wBAAgB;IAAhB,qBAAgB;SAAhB,gBAAgB;CAChB,qBAAqB;AACtB;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,eAAe;CACf,6BAA6B;CAC7B,8BAA8B;CAC9B,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,cAAc;AACf;;AAEA;CACC,eAAe;CACf,eAAe;CACf,kCAAkC;AACnC;;AAEA;CACC;EACC,YAAY;EACZ,cAAc;CACf;AACD;;AAEA;CACC;EACC,cAAc;CACf;AACD;;AAEA;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,sCAAsC;CACvC;;AAED;;AAEA;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;AACD;;AAEA,oEAAoE;;AAEpE;CACC;AACD;;AAEA;CACC,sBAAsB;AACvB;;AAEA,2BAA2B;;AAE3B,6BAA6B;;AAC7B;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,2CAA2C;CAC3C,mBAAmB;AACpB;;ACvUA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;;ACJA;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;AACxB;;AC7BA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;ACxNA;EACE,aAAa;EACb,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,4BAA4B;EAC5B,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE;EACF;AACF","sourcesContent":[".commonHeaderAdmin {\n\tposition: fixed !important;\n}\n\n.adminLayout {\n\tpadding-top: 64px !important;\n}\n\n.box h2 {\n\tfont-size: 21px;\n\tfont-weight: 600;\n}\n\n.exportLink {\n\tmargin-bottom: -29px;\n}\n\n.blockCenter {\n\tfloat: none !important;\n\tdisplay: block;\n\tmargin: 0 auto;\n\tmargin-top: 30px;\n}\n\n.panelHeader {\n\tpadding-bottom: 18px !important;\n\tpadding: 24px 15px;\n\tborder-radius: 6px !important;\n\tborder: 1px solid var(--primary-border)\n}\n\n.currencyselect {\n\twidth: 100%;\n\tmargin-right: 0px;\n}\n\n.panelHeader {\n\toverflow: hidden;\n\tposition: relative;\n}\n\n.mar0 {\n\tmargin-left: 0;\n\tmargin-right: 0;\n}\n\n@media screen and (max-width: 767px) {\n\t.blockCenter {\n\t\tpadding: 0px;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 24px 5px;\n\t}\n}","@import './newcommonstyle.css';\n\n/** Admin - Common - Start **/\n.sideAdminPageWrapper {\n\tmargin-left: var(--siteAdmin-sideBar-width);\n\tposition: relative;\n\tpadding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;\n}\n\n.panelHeader {\n\tborder-radius: 0;\n\twidth: 100%;\n\tdisplay: block;\n\tfont-size: 16px;\n\tpadding-bottom: 12px;\n\tborder-bottom: 1px solid var(--primary-border);\n\tbackground-color: var(--background-primary);\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.select {\n\tposition: relative;\n\tdisplay: inline-block;\n\tvertical-align: bottom;\n\tmargin-right: 5px;\n}\n\n.noMargin {\n\tmargin: 0px;\n}\n\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.labelTextNew {\n\tfont-size: 16px;\n\tline-height: 24px;\n\tfont-weight: 600;\n\tmargin: 0 0 6px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.displayInline {\n\tdisplay: inline-block;\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n.btnUPdate {\n\tdisplay: inline-block;\n}\n\n.btnModalDelete {\n\tdisplay: inline-block;\n\tmargin-left: 15px;\n}\n\n.radioBtn {\n\tposition: relative;\n\ttop: 1px;\n\tvertical-align: middle;\n}\n\n.backgroundImg {\n\tpadding-top: 80%;\n\tbackground-position: top center;\n\tbackground-size: cover;\n}\n\n@media screen and (max-width: 767px) {\n\t.btnUPdate {\n\t\tdisplay: block;\n\t\tmargin-bottom: 12px;\n\t}\n\n\t.btnModalDelete {\n\t\tdisplay: block;\n\t\tmargin-left: 0px;\n\t}\n\n\t.btnWidth {\n\t\twidth: 100%;\n\t}\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n/******************* Admin Banner Image Section Start ****************/\n\n.bannerImageBg {\n\tpadding-top: 60%;\n\tbackground-repeat: no-repeat;\n\tbackground-size: contain;\n\tborder-radius: 4px;\n\tbackground-position: center;\n\tbackground-color: var(--secondary-gray-bg);\n\tborder: 1px dashed var(--primary-border);\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: -12px;\n\tright: 4px;\n}\n\n/*******************Admin Modal Start **********************/\n\n.modalRoot {\n\tpadding: 32px;\n}\n\n.modalBorderBottom {\n\tborder-bottom: 5px solid var(--primary-bg);\n\tborder-bottom-left-radius: 14px;\n\tborder-bottom-right-radius: 14px;\n}\n\n.logInModalBody {\n\tpadding: 0px;\n}\n\n/*************** Admin TableNew Design Start**************************/\n\n.exportSection {\n\tbackground: #f5f5f5;\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder-top-left-radius: 6px;\n\tborder-top-right-radius: 6px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--primary-foreground) !important;\n\ttext-decoration: none !important;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 12px;\n}\n\n.exportLinkImg {\n\tbackground: var(--common-white-primary-bg);\n\tpadding: 10px;\n\tborder-radius: 4px;\n\tdisplay: inline-block;\n}\n\n.vtrMiddle {\n\tvertical-align: middle;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 6px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-bottom: 1px solid var(--primary-border);\n}\n\n.profileImageSection {\n\twidth: 100%;\n\theight: 100px;\n\tmax-width: 100px;\n\tmax-height: 100px;\n\tborder-radius: 50%;\n}\n\n.lastviewInner {\n\tpadding: 10px;\n}\n\n.whyHostHoriLine {\n\tmargin: 30px 0;\n}\n\n.tableGrid {\n\tdisplay: grid;\n\tgrid-template-columns: 50% 50%;\n\tcolumn-gap: 10px;\n\tword-wrap: break-word;\n}\n\n.headingContent {\n\tfont-size: 18px;\n\tfont-weight: 500;\n}\n\n.refundTextColor {\n\tcolor: var(--alert-color);\n\tfont-size: 18px;\n\ttext-decoration: line-through;\n\ttext-decoration-thickness: 2px;\n\ttext-decoration-color: var(--black-color);\n}\n\n.dividerLine {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin: 30px 0;\n}\n\n.smallContent {\n\tfont-size: 14px;\n\tmargin-top: 6px;\n\tcolor: var(--secondary-foreground);\n}\n\n@media (max-width: 1200px) and (min-width: 1024px) {\n\t.sideAdminPageWrapper {\n\t\theight: 100%;\n\t\toverflow: auto;\n\t}\n}\n\n@media (max-width:1199px) {\n\t.sideAdminPageWrapper {\n\t\tmargin-left: 0;\n\t}\n}\n\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n\n}\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n}\n\n/*************** Admin TableNew Design End**************************/\n\n.ChangeToUpperCase {\n\ttext-transform: uppercase\n}\n\n.noBorder {\n\tborder: 0px !important;\n}\n\n/** Admin - Common - End **/\n\n/* site Admin utility Start */\n.siteAdminHeading {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 700;\n\tmargin: 0 0 24px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.siteAdminSubHeading {\n\tfont-size: 18px;\n\tline-height: 26px;\n\tfont-weight: 600;\n\tmargin: 0 0 12px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.adminFormDivider {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin-bottom: 24px;\n}",".errorMessage {\n  margin: 5px 0px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n}","@import '../utils.css';\n\n.panelHeader {\n  border-radius: 0;\n  width: 100%;\n  display: block;\n  font-size: 16px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid var(--primary-border);\n}\n\n.formGroup {\n  margin-bottom: 6px;\n}\n\n.select {\n  position: relative;\n  display: inline-block;\n  vertical-align: bottom;\n  margin-right: 5px;\n}\n\n.labelText {\n  font-size: 14px;\n  color: var(--secondary-foreground);\n  margin: 6px 0px;\n  line-height: 1.43;\n  font-weight: normal;\n  vertical-align: middle;\n}",".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}","@import '../admin-common.css';\n@import '../admin-form.css';\n@import '../../helpers.css';\n\n.loginMainBg {\n  display: grid;\n  grid-template-columns: 50% 50%;\n  height: 100vh;\n}\n\n.formSection {\n  padding: 19% 0;\n  background-color: var(--primary-gray-bg);\n}\n\n.formInner {\n  width: 100%;\n  max-width: 450px;\n  margin: 0 auto;\n  padding: 0px 15px;\n}\n\n.loginBg {\n  width: 100%;\n  height: 100%;\n  padding-top: 64%;\n  background-repeat: no-repeat;\n  background-size: contain;\n  background-position: 50% 50%;\n}\n\n.loginbtn {\n  padding: 13px 21px !important;\n}\n\n.loginInput {\n  height: 50px !important;\n}\n\n.loginLabel {\n  font-weight: 100 !important;\n  font-size: 18px !important;\n}\n\n.loginTitle {\n  font-size: 30px;\n  font-weight: 700;\n  margin: 12px 0 0 0;\n}\n\n.loginTitleScetion {\n  text-align: center;\n  margin-bottom: 42px;\n}\n\n.loginTitleScetion img {\n  width: 100%;\n  max-width: 120px;\n}\n\n.logoColor {\n  color: var(--primary-bg);\n}\n\n.whiteColor {\n  color: var(--common-primary-white-foreground);\n}\n\n.logoTextTabViewWidth {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  display: block;\n  width: 100%;\n  max-width: 180px;\n  white-space: nowrap;\n  margin: auto;\n}\n\n.rentalText {\n  font-size: 20px;\n  font-weight: 600;\n}\n\n@media screen and (max-width: 767px) {\n  .loginMainBg {\n    grid-template-columns: 100%;\n  }\n\n  .loginBg {\n    display: none\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"commonHeaderAdmin": `AdminLoginForm-commonHeaderAdmin-xAuxy`,
	"adminLayout": `AdminLoginForm-adminLayout-ZNhsv`,
	"box": `AdminLoginForm-box-KpZj_`,
	"exportLink": `AdminLoginForm-exportLink-pLWrL`,
	"blockCenter": `AdminLoginForm-blockCenter-Oaw9F`,
	"panelHeader": `AdminLoginForm-panelHeader-LCVWK`,
	"currencyselect": `AdminLoginForm-currencyselect-IiGZn`,
	"mar0": `AdminLoginForm-mar0-g04nY`,
	"sideAdminPageWrapper": `AdminLoginForm-sideAdminPageWrapper-A6aOk`,
	"table": `AdminLoginForm-table-dpwsJ`,
	"tableRow": `AdminLoginForm-tableRow-jYccS`,
	"tableCell": `AdminLoginForm-tableCell-JB3Y0`,
	"formGroup": `AdminLoginForm-formGroup-zV1G5`,
	"select": `AdminLoginForm-select-Pz7lr`,
	"noMargin": `AdminLoginForm-noMargin-i_8Re`,
	"labelTextNew": `AdminLoginForm-labelTextNew-MdcX8`,
	"displayInline": `AdminLoginForm-displayInline-Lewtx`,
	"btnUPdate": `AdminLoginForm-btnUPdate-oU7lq`,
	"btnModalDelete": `AdminLoginForm-btnModalDelete-Db4_H`,
	"radioBtn": `AdminLoginForm-radioBtn-LT4oE`,
	"backgroundImg": `AdminLoginForm-backgroundImg-ssCHZ`,
	"btnWidth": `AdminLoginForm-btnWidth-iIFg9`,
	"bannerImageBg": `AdminLoginForm-bannerImageBg-Y2ZS3`,
	"bannerDelete": `AdminLoginForm-bannerDelete-bPGpT`,
	"modalRoot": `AdminLoginForm-modalRoot-Pfx0Y`,
	"modalBorderBottom": `AdminLoginForm-modalBorderBottom-wq5wp`,
	"logInModalBody": `AdminLoginForm-logInModalBody-LCq7y`,
	"exportSection": `AdminLoginForm-exportSection-P5dwC`,
	"exportSectionGridSub": `AdminLoginForm-exportSectionGridSub-z7Lf0`,
	"exportText": `AdminLoginForm-exportText-zMDXf`,
	"exportLinkImg": `AdminLoginForm-exportLinkImg-Eh2R4`,
	"vtrMiddle": `AdminLoginForm-vtrMiddle-s3ctI`,
	"exportImg": `AdminLoginForm-exportImg-NO3_N`,
	"profileViewlabel": `AdminLoginForm-profileViewlabel-lGl8E`,
	"profileViewMainContent": `AdminLoginForm-profileViewMainContent-YjYPL`,
	"profileViewMain": `AdminLoginForm-profileViewMain-yIRiz`,
	"profileViewInner": `AdminLoginForm-profileViewInner-GuLXP`,
	"profileImageSection": `AdminLoginForm-profileImageSection-fQodG`,
	"lastviewInner": `AdminLoginForm-lastviewInner-CNOve`,
	"whyHostHoriLine": `AdminLoginForm-whyHostHoriLine-LUWXw`,
	"tableGrid": `AdminLoginForm-tableGrid-vRcn0`,
	"headingContent": `AdminLoginForm-headingContent-fY6qD`,
	"refundTextColor": `AdminLoginForm-refundTextColor-uO92s`,
	"dividerLine": `AdminLoginForm-dividerLine-iOOt9`,
	"smallContent": `AdminLoginForm-smallContent-kOBdb`,
	"ChangeToUpperCase": `AdminLoginForm-ChangeToUpperCase-JwSiL`,
	"noBorder": `AdminLoginForm-noBorder-FbkqH`,
	"siteAdminHeading": `AdminLoginForm-siteAdminHeading-nbRM2`,
	"siteAdminSubHeading": `AdminLoginForm-siteAdminSubHeading-Jfe6Z`,
	"adminFormDivider": `AdminLoginForm-adminFormDivider-_CwcF`,
	"errorMessage": `AdminLoginForm-errorMessage-w3bhr`,
	"labelText": `AdminLoginForm-labelText-c7RYk`,
	"space1": `AdminLoginForm-space1-uS0vZ`,
	"space2": `AdminLoginForm-space2-C0XyK`,
	"space3": `AdminLoginForm-space3-Vd7he`,
	"space4": `AdminLoginForm-space4-R8RQA`,
	"space5": `AdminLoginForm-space5-BsE7g`,
	"space6": `AdminLoginForm-space6-UVaRx`,
	"space7": `AdminLoginForm-space7-RFXLY`,
	"spaceTop8": `AdminLoginForm-spaceTop8-L6vih`,
	"spaceTop1": `AdminLoginForm-spaceTop1-YGy0m`,
	"spaceTop2": `AdminLoginForm-spaceTop2-N6jz1`,
	"spaceTop3": `AdminLoginForm-spaceTop3-Mory8`,
	"spaceTop4": `AdminLoginForm-spaceTop4-JDKRc`,
	"spaceTop5": `AdminLoginForm-spaceTop5-n2IoF`,
	"spaceTop6": `AdminLoginForm-spaceTop6-jTOxF`,
	"spaceTop7": `AdminLoginForm-spaceTop7-LL78l`,
	"padding1": `AdminLoginForm-padding1-Elvxu`,
	"padding2": `AdminLoginForm-padding2-Cvntx`,
	"padding3": `AdminLoginForm-padding3-D1Ue1`,
	"padding4": `AdminLoginForm-padding4-eKsOE`,
	"padding5": `AdminLoginForm-padding5-qjgyj`,
	"padding6": `AdminLoginForm-padding6-WCOah`,
	"padding7": `AdminLoginForm-padding7-LdHzO`,
	"paddingTop1": `AdminLoginForm-paddingTop1-TbZGM`,
	"paddingTop2": `AdminLoginForm-paddingTop2-L_zmL`,
	"paddingTop3": `AdminLoginForm-paddingTop3-uGGks`,
	"paddingTop4": `AdminLoginForm-paddingTop4-u1ujn`,
	"paddingTop5": `AdminLoginForm-paddingTop5-B4ku8`,
	"paddingTop6": `AdminLoginForm-paddingTop6-JAzzV`,
	"paddingTop7": `AdminLoginForm-paddingTop7-u17kr`,
	"noPadding": `AdminLoginForm-noPadding-vwPF0`,
	"textBold": `AdminLoginForm-textBold-gylX9`,
	"textBolder": `AdminLoginForm-textBolder-p2lyt`,
	"textNormal": `AdminLoginForm-textNormal-dyYo3`,
	"spaceBottom20": `AdminLoginForm-spaceBottom20-VG6kQ`,
	"spaceBottom10": `AdminLoginForm-spaceBottom10-zccoE`,
	"marginNone": `AdminLoginForm-marginNone-5DLZo`,
	"spaceBottom15": `AdminLoginForm-spaceBottom15-lVaL1`,
	"marginTopNone": `AdminLoginForm-marginTopNone-E5TLP`,
	"spaceTop11": `AdminLoginForm-spaceTop11-Nm_t8`,
	"spaceTop21": `AdminLoginForm-spaceTop21-n7wcp`,
	"spaceTop20": `AdminLoginForm-spaceTop20-T8CR2`,
	"spaceTop10": `AdminLoginForm-spaceTop10-uYrPR`,
	"textDarkBlue": `AdminLoginForm-textDarkBlue-w_yWE`,
	"textLightBlue": `AdminLoginForm-textLightBlue-I4mJt`,
	"textLightSandleGreen": `AdminLoginForm-textLightSandleGreen-ksOIB`,
	"textLightBrown": `AdminLoginForm-textLightBrown-a8ufN`,
	"textMediumMaroon": `AdminLoginForm-textMediumMaroon-Nq12N`,
	"textBrown": `AdminLoginForm-textBrown-HnTOj`,
	"textMaroon": `AdminLoginForm-textMaroon-Zy5ai`,
	"textDarkBrown": `AdminLoginForm-textDarkBrown-PKPB1`,
	"textMediumBrown": `AdminLoginForm-textMediumBrown-S0ZmG`,
	"textSkyBlue": `AdminLoginForm-textSkyBlue-wu94v`,
	"textGray": `AdminLoginForm-textGray-ZkAwj`,
	"loginMainBg": `AdminLoginForm-loginMainBg-yMjYH`,
	"formSection": `AdminLoginForm-formSection-bIAcb`,
	"formInner": `AdminLoginForm-formInner-K8Qah`,
	"loginBg": `AdminLoginForm-loginBg-AcqCe`,
	"loginbtn": `AdminLoginForm-loginbtn-Mx3Ej`,
	"loginInput": `AdminLoginForm-loginInput-YP8KD`,
	"loginLabel": `AdminLoginForm-loginLabel-ZRmax`,
	"loginTitle": `AdminLoginForm-loginTitle-ufieP`,
	"loginTitleScetion": `AdminLoginForm-loginTitleScetion-sh6M8`,
	"logoColor": `AdminLoginForm-logoColor-t0imA`,
	"whiteColor": `AdminLoginForm-whiteColor-AsThI`,
	"logoTextTabViewWidth": `AdminLoginForm-logoTextTabViewWidth-C5AVC`,
	"rentalText": `AdminLoginForm-rentalText-w4r_Z`
};
module.exports = ___CSS_LOADER_EXPORT___;
